import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AppRoutingKeys, ErrorCodes, LoadingIndicatorState } from '@shared';
import { RestoreDatabaseService } from '@database/workspace';
import { LoggingService } from '@shared/logging';

@Injectable()
export class DatabaseInitializedGuard {
	public constructor(
		private restoreDatabaseService: RestoreDatabaseService,
		private loadingIndicator: LoadingIndicatorState,
		private loggingService: LoggingService
	) {}

	/* eslint-disable @typescript-eslint/no-unused-vars */
	public async canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
		const workfileId = _route.paramMap.get(AppRoutingKeys.queryParamsMap.workfileId);
		const isDatabaseInitialized = this.restoreDatabaseService.isDatabaseInitialized(workfileId);
		const workfileExists = await this.restoreDatabaseService.worfileExists(workfileId);

		if (!workfileExists) {
			//todo: navigate to a not found page or import workfile page
			throw new Error('Specified workfile does not exist');
		}

		//todo: double check this
		if (isDatabaseInitialized) {
			return true;
		}

		this.loadingIndicator.setIsLoading(true);

		try {
			await this.restoreDatabaseService.setActiveWorkfileDatabase(workfileId);
		} catch (error) {
			this.loadingIndicator.setIsLoading(false);
			//todo: navigate to a not found page or import workfile page
			this.loggingService.error(ErrorCodes.RestoreDatabaseError, error);
			throw error;
		} finally {
			this.loadingIndicator.setIsLoading(false);
		}

		return true;
	}
}
